import { DefaultTheme } from '@react-navigation/native';
import Colors from './Colors';

export default {
  // used as default spacing increments (i.e. see Typography padding)
  spacing: 8,
  // NavigationContainer theme
  navigationTheme: {
    ...DefaultTheme,
    colors: {
      ...DefaultTheme.colors,
      primary: Colors.primary,
      background: Colors.primaryPurple
    }
  },
  stackScreenOptions: {
    title: '',
    headerTransparent: true,
    headerStyle: {
      backgroundColor: 'transparent',
      // backgroundColor: Colors.primary,
      shadowColor: 'transparent',
      borderWidth: 0,
      elevation: 0
    },
    headerTintColor: '#fff'
  }
};
